import React, { useState } from 'react';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import Box from '@mui/material/Box';
import { DT_MESSAGES, MATERIAL_AVAILABILITY, MODULE_TYPE, OCPLC_ADMIN, RESTRICTED_STATUSES_ADMIN_COMPLETE, RESTRICTED_STATUSES_ADMIN_DATA_TRANSPORT, RESTRICTED_STATUSES_COMPLETE, RESTRICTED_STATUSES_DATA_TRANSPORT, ROLE_NAME_FOR_ADMIN, VERSION_0002, VERSION_0003 } from 'constants/ocplcConstants';
import { iconButtonStyle } from 'pages/DashboardHelpers';
import { isDTButtonDisabled, canTransportData, hasRestrictedStatus, isCompleteDisabled, isisDTdisable } from 'pages/Utils/OcplcUtil';
import { dataTransportAction, dashboardDataTransport } from 'actions/ocplcAction';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmationDialog from 'components/ConfirmationDialog';
import { useLocation } from 'react-router-dom';
import { IconButton, Tooltip } from '@mui/material';
import FactCheckSharpIcon from '@mui/icons-material/FactCheckSharp';
import CloudSyncSharpIcon from '@mui/icons-material/CloudSyncSharp';
import { ButtonSpinner } from 'components/ButtonSpinner';


const DataTransportDropdown = ({ dashboardDTDisabled, tableData, version, selectKmat,selectedCategory, productGroup, productLineID, disabled, userRole, region, assignedRole, checkedRows, setCheckedRows, userEmail, selectedTable, selectedProductGroup, setSelectedIds, selectedIds, setisLoading,isLoading }) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const [isDashboardDialogOpen, setIsDashboardDialogOpen] = useState(false); 
    const [dialogState, setDialogState] = useState({ type: '', open: false });
    const [selectedItems, setSelectedItems] = useState([]);

    const isParametersMode = location.pathname.includes('parameters');
    const isLocalizationMode = location.pathname.includes('localization');

    const isDisabled = isCompleteDisabled(userRole, region, assignedRole, checkedRows, selectedTable, version);
    const isDTdisable = isisDTdisable(assignedRole,checkedRows,selectedTable,version)
    const loadCount = useSelector(state => state.ocplc.loadCount);

    const openDashboardDialog = () => setIsDashboardDialogOpen(!isDashboardDialogOpen);

    const handleCheckboxChange = (event) => {
        const { checked, name } = event.target;
        if (name === 'Full Data Transport') {
            setSelectedItems(checked ? ['Full Data Transport', ...tableData.map(item => item.subCategory)] : []);
        } else {
            const newSelectedItems = checked ? [...selectedItems, name] : selectedItems.filter(item => item !== name);
            if (newSelectedItems.length === tableData.length) {
                setSelectedItems(['Full Data Transport', ...tableData.map(item => item.subCategory)]);
            } else {
                setSelectedItems(newSelectedItems);
            }
        }
    };

    const handleDashboardDTConfirm = () => {
        const dataTransportObjs = checkedRows.map(item => ({
            productGroup: item.productGroup,
            productFamily: item.kmatId
        }));
        dispatch(dashboardDataTransport(userEmail, selectedItems, dataTransportObjs,setisLoading));
        setCheckedRows([]);
        setSelectedIds([]);
        setSelectedItems([]);
        openDashboardDialog();
    };

    const handleConfirm = (actionType) => {
        const pkIds = checkedRows.map(row => row.pkId);
        dispatch(dataTransportAction(actionType, pkIds, userEmail, version, region, selectKmat ,selectedCategory, productGroup, productLineID, selectedTable, selectedProductGroup, checkedRows));
        setCheckedRows([]);
        setSelectedIds([]);
        setSelectedItems([]);
        setDialogState({ type: '', open: false }); 
    };

    const handleCancelClick = () => {
        setSelectedItems([]);
        setIsDashboardDialogOpen(false);
        setDialogState({ type: '', open: false });
        setSelectedIds([]);
    };

    const shouldDisableCheckbox = (item) => {
        return selectedItems.includes('Full Data Transport') && item.subCategory !== 'Full Data Transport' ||
               selectedItems.length > 0 && selectedItems[0] !== 'Full Data Transport' && item.subCategory === 'Full Data Transport';
    };

    const options = [{ subCategory: 'Full Data Transport' }, ...tableData];

   const handleDataTransportClick = () => {
    const isMaterial = selectedTable === MATERIAL_AVAILABILITY;
    const isAdmin = assignedRole === OCPLC_ADMIN;

    if (checkedRows.length > loadCount) {
        setDialogState({ type: 'exceedLoadCount', open: true });
        return;
    }

    if (
        (isMaterial && isAdmin && hasRestrictedStatus(checkedRows, RESTRICTED_STATUSES_ADMIN_DATA_TRANSPORT)) ||
        (!isMaterial || !isAdmin) && hasRestrictedStatus(checkedRows, RESTRICTED_STATUSES_DATA_TRANSPORT)
    ) {
        setDialogState({
            type: 'restrictedStatus',
            action: 'dataTransport',
            open: true,
        });
        return;
    }

    setDialogState({ type: 'dataTransport', open: true });
};

    const handleDashboardDTClick = () => {
        if (checkedRows.length > loadCount) {
            setDialogState({ type: 'exceedLoadCount', open: true });
        } else {
            const transportValidation = canTransportData(checkedRows);
            if (transportValidation.isValid) {
                setDialogState({
                    type: 'transportAllowed',
                    open: true,
                    message: transportValidation.message,
                });
            } else {
                openDashboardDialog();
            }
        }
    };

    const handleCompleteClick = () => {
    const isMaterial = selectedTable === MATERIAL_AVAILABILITY;
    const isAdmin = assignedRole === OCPLC_ADMIN;

    if(!isAdmin && checkedRows.some(row=> ![userEmail,"DT-NIGHTLY-JOB","OCKB","OCKB-NIGHTLY-JOB"].includes(row.whoChanged))){
        const author = checkedRows.find(row => ![userEmail,"DT-NIGHTLY-JOB","OCKB","OCKB-NIGHTLY-JOB"].includes(row.whoChanged))?.whoChanged;
        setDialogState({
            type: 'completeWarning',
            action: 'complete',
            open: true,
            message: `Record is already accessed and saved by ${author}`
        });
        return;
    }

    if(!isAdmin && checkedRows.some(row=>RESTRICTED_STATUSES_COMPLETE.includes(row.status) && checkedRows.some(r => [userEmail,"DT-NIGHTLY-JOB","OCKB","OCKB-NIGHTLY-JOB"].includes(r.whoChanged))) ){
        setDialogState({
            type: 'restrictedStatus',
            action: 'complete',
            open: true,
        });
        return;
    }
    if (
        (isMaterial && isAdmin && hasRestrictedStatus(checkedRows, RESTRICTED_STATUSES_ADMIN_COMPLETE)) || 
        (!isMaterial || isAdmin) && hasRestrictedStatus(checkedRows, RESTRICTED_STATUSES_COMPLETE)
    ) {
        setDialogState({
            type: 'restrictedStatus',
            action: 'complete',
            open: true,
        });
        return;
    }

    setDialogState({ type: 'complete', open: true });
};
 

    const DataTransportButton = ({ onClick, disabled }) => (
         <Tooltip title="Data Transport">
            <span>
                <IconButton
                    color="primary"
                    sx={{ ...iconButtonStyle, marginLeft: "10px" }}
                    onClick={onClick}
                    disabled={disabled}
                    size="large"
                >
                    <CloudSyncSharpIcon />
                </IconButton>
            </span>
        </Tooltip>
    );

    return (
        <>
            {version === VERSION_0002 || isParametersMode || isLocalizationMode ? (
                <>
                    <Tooltip title="Complete">
                        <span>
                            <IconButton
                                color="primary"
                                sx={{ ...iconButtonStyle, marginLeft: "10px" }}
                                onClick={handleCompleteClick}
                                disabled={isDisabled}
                                size ="large"
                            >
                                <FactCheckSharpIcon />
                            </IconButton>
                        </span>
                    </Tooltip>
                    <DataTransportButton onClick={handleDataTransportClick} disabled={isDTdisable} />
                </>
            ) : (
                <>
                    {version !== VERSION_0003 && (
                        <DataTransportButton onClick={handleDashboardDTClick} disabled={dashboardDTDisabled} />
                    )}
                    {isLoading ? <ButtonSpinner/> : <ConfirmationDialog
                        open={isDashboardDialogOpen}
                        onClose={handleCancelClick}
                        onConfirm={handleDashboardDTConfirm}
                        title={DT_MESSAGES.SELECT_TABLE_TITLE}
                        content={
                            <Box sx={{ display: 'grid' }}>
                                {options.map((item, index) => (
                                    <FormControlLabel
                                        key={index}
                                        control={
                                            <Checkbox
                                                checked={selectedItems.includes(item.subCategory)}
                                                onChange={handleCheckboxChange}
                                                name={item.subCategory}
                                                disabled={shouldDisableCheckbox(item)}
                                            />
                                        }
                                        label={item.subCategory}
                                    />
                                ))}
                            </Box>
                        }
                        caption="Confirm"
                        secondaryCaption="Cancel"
                        bgColor="#0278ab"
                        disabled={selectedItems.length === 0}
                    />}
                </>
            )}
            {dialogState.open && (dialogState.type === 'complete' || dialogState.type === 'dataTransport') && (
            <ConfirmationDialog
                open={dialogState.open}
                onClose={handleCancelClick}
                onConfirm={() => handleConfirm(dialogState.type)}
                title={dialogState.type === 'complete' ? 'Complete' : 'Data Transport'}
                content={DT_MESSAGES.CONFIRMATION_CONTENT}
                caption="Confirm"
                secondaryCaption="Cancel"
                bgColor="#0278ab"
            />
            )}
            {dialogState.open && dialogState.type === 'exceedLoadCount' && (
                <ConfirmationDialog
                    open={dialogState.open}
                    onClose={handleCancelClick}
                    content={DT_MESSAGES.LOAD_COUNT_EXCEEDED_CONTENT(loadCount)}
                    bgColor="#0278ab"
                />
            )}
            {dialogState.open && dialogState.type === 'restrictedStatus' && (
                <ConfirmationDialog
                    open={dialogState.open}
                    onClose={handleCancelClick}
                    content={
                        dialogState.action === 'dataTransport'
                            ? DT_MESSAGES.RESTRICTED_STATUS_DATA_TRANSPORT
                            : DT_MESSAGES.RESTRICTED_STATUS_COMPLETE
                    }
                    bgColor="#0278ab"
                />
            )}
            {dialogState.open && dialogState.type === 'transportAllowed' && (
                <ConfirmationDialog
                    open={dialogState.open}
                    onClose={handleCancelClick}
                    content={dialogState.message}
                    bgColor="#0278ab"
                />
            )}

            {dialogState.open && dialogState.type === 'completeWarning' && (
                <ConfirmationDialog
                    open={dialogState.open}
                    onClose={handleCancelClick}
                    content={dialogState.message}
                    bgColor="#0278ab"
                />
            )}
        </>
    );
};

export default DataTransportDropdown;
